module.exports = __webpack_public_path__ + "static/media/ann.8df66ab2.png";